import React from 'react';
import { Stethoscope, Sparkles, Baby, Award, Check } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Stethoscope: Stethoscope,
  Sparkles: Sparkles,
  Baby: Baby,
  Award: Award
};

const Services = () => {
  return (
    <section id="services" className="section-padding bg-[#FAFAF9]">
      <div className="container mx-auto px-8 lg:px-16">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="divider-accent mx-auto"></div>
          <h2 className="heading-1 text-[#1C1917] mb-6 mt-6">
            Dental Services
          </h2>
          <p className="body-large text-[#57534E]">
            Whether it's a toothache, an overdue cleaning visit or complete makeover smile, 
            we provide you with the most personalized care possible. Each patient is unique 
            and we create personalized appointments aimed at fulfilling your needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-10 lg:gap-12">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="product-card bg-[#FFFFFF] hover-lift overflow-hidden group"
              >
                {/* Service Image */}
                <div className="relative overflow-hidden h-72">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/70 via-[#1C1917]/20 to-transparent"></div>
                  
                  {/* Icon Overlay */}
                  <div className="absolute bottom-8 left-8">
                    <div className="w-14 h-14 bg-[#FFFFFF] rounded-md flex items-center justify-center shadow-elevated">
                      <IconComponent className="w-7 h-7 text-[#0F766E]" strokeWidth={1.5} />
                    </div>
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-10">
                  <h3 className="heading-2 text-[#1C1917] mb-4">
                    {service.title}
                  </h3>
                  <p className="body-regular text-[#57534E] mb-8">
                    {service.description}
                  </p>

                  {/* Service Items List */}
                  <ul className="space-y-4">
                    {service.items.map((item, index) => (
                      <li key={index} className="flex items-start gap-3 group/item">
                        <div className="w-5 h-5 rounded-full bg-[#F5F5F4] flex items-center justify-center mt-0.5 flex-shrink-0 transition-colors duration-300 group-hover/item:bg-[#0F766E]/10">
                          <Check className="w-3 h-3 text-[#0F766E]" strokeWidth={2.5} />
                        </div>
                        <span className="body-small text-[#78716C]">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom Statement */}
        <div className="text-center mt-20 pt-16 border-t divider-refined">
          <p className="body-large text-[#57534E] max-w-2xl mx-auto">
            Our staff is ready to answer your questions and attend to your dental needs with the highest level of professional care.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
